// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePanelRightOpen as RawLucidePanelRightOpen } from "lucide-react";
export const LucidePanelRightOpen = /* @__PURE__ */ createIcon(RawLucidePanelRightOpen, "LucidePanelRightOpen", 2);
